<template>
    <MainContainer>
        <div class="home w-50 mx-auto mt-5 text-center">
            <h2>FiBu</h2>
            <p>Die Verwaltung wird nach und nach umgezogen. Die FiBu mit ihrer kompletten Funktionalität steht bis zum vollendeten Umzug noch in der alten Form zur Verfügung unter:
                <b-link
                    href="http://musikverein-duesseldorf.de/verwaltung"
                >http://musikverein-duesseldorf.de/verwaltung</b-link>
            </p>
        </div>
    </MainContainer>
</template>

<script>
// @ is an alias to /src
import MainContainer from "@/components/MainContainer/MainContainer";

export default {
    name: "fibu",
    components: {
        MainContainer
    }
};
</script>
